import LogoNav from '../../../assets/logo/logo_nav.svg'
import LogoBranca from '../../../assets/logo/logo_branca.png'
import { Fragment, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import NavbarUser from './NavbarUser'
import { useDispatch, useSelector } from 'react-redux'
import { Tab, Tabs } from '@mui/material'
import { TextClose } from '../../../../views/home/livros/components/TextClose/TextClose'
import CategoriasCelular from '../../../../views/home/filtros/components/categoriasCelular/CategoriasCelular'
import './ThemeNavbar.scss'
import { useTheme, useMediaQuery, IconButton } from '@material-ui/core'
import { Favorite } from '@material-ui/icons'

const ThemeNavbar = props => {
  const { skin, setSkin, setMenuVisibility } = props
  const store = useSelector(state => state.leitura);

  const [tabIndex, setTab] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const history = useHistory();
  const dispatch = useDispatch();

  const theme = useTheme()
  const isMobileMedia = useMediaQuery(theme.breakpoints.down('sm'))
  const [favoriteChecked, setFavoriteChecked] = useState(false)
  const storeFiltroFavoritos = useSelector(state => state.filtros.favoritos)

  useEffect(() => {
    setFavoriteChecked(storeFiltroFavoritos)
  }, [storeFiltroFavoritos])

  const handleFavoritesClick = () => {
    const action = {
      type: 'GET_FAVORITOS',
      favoritos: !favoriteChecked
    }
    dispatch(action)
    setFavoriteChecked(!favoriteChecked)
  }

  const goToHome = () => {
    const action = {
      type: 'SET_HIDE_NAV_BAR',
      navBarHide: false
    };

    dispatch(action);
    history.push('/livros');
  }

  const handleChange = (event, tabValue) => {

    const action = {
      type: 'CHANGE_TAB',
      tabIndex: tabValue
    }

    dispatch(action);
  };

  const onTabClose = async (index) => {

    const actionLeituras = {
      type: 'REMOVE_LIVRO_LEITURA',
      listaLeituraIndex: index - 1
    }
    await dispatch(actionLeituras);

    const actionTabs = {
      type: 'REMOVE_TABS',
      tabIndex: index - 1
    }
    await dispatch(actionTabs);

    if (index === tabIndex) handleChange(null, index - 1);
    else if (store.tabs.length === 0) handleChange(null, 0);
    else if (tabIndex > store.tabs.length) handleChange(null, tabIndex - 1);
  }

  useEffect(() => {
    setTab(store.activeTab);
  }, [store.activeTab]);
  
  return (
    <Fragment>
      <div className="navbar-container">
        <div className="navbar-left">
          <CategoriasCelular />
        </div>
        {isMobile && (
          <div className="navbar-favorite">
            <IconButton
              onClick={handleFavoritesClick}
              className="favorite-button"
              aria-label="favoritos"
            >
              <Favorite style={{ 
                color: favoriteChecked ? '#df9c37' : 'grey',
                fontSize: '24px'
              }} />
            </IconButton>
          </div>
        )}
        <div className={isMobile ? 'logo-container-mobile' : ''}>
          <img src={skin !== 'dark' ? LogoNav : LogoBranca} className="main-logo" alt="Logo Intuitiva" onClick={() => goToHome()} />
        </div>
        {!isMobile && (
          <Tabs
            value={tabIndex}
            onChange={handleChange}
            variant="scrollable"
            aria-label="basic tabs force scrollable"
            className={`tabsBox backgroundDark`}
            scrollButtons="auto"
          >
            <Tab label={'Catálogo'} className='simpleTab' />
            {store.tabs ? store.tabs.map((pagina, index) => {
              return <Tab label={<TextClose text={pagina.titulo} closeHandler={async () => await onTabClose(index + 1)} />} key={index + 1} className='simpleTab' />
            }) : <></>}
          </Tabs>
        )}
        <div className='email-top-right'>
          <NavbarUser skin={skin} setSkin={setSkin} />
        </div>
      </div>
    </Fragment>
  )
}

export default ThemeNavbar;